
import React, { useState, useEffect } from 'react';
import { Lesson } from '../../types';
import LoadingSpinner from '../ui/LoadingSpinner';
import { api } from '../../utils/api';

interface JoinWithCodeProps {
  onStartSession: (lesson: Lesson) => void;
}

const JoinWithCode: React.FC<JoinWithCodeProps> = ({ onStartSession }) => {
  const [code, setCode] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const codeFromUrl = params.get('code');
    if (codeFromUrl) {
      setCode(codeFromUrl.toUpperCase());
    }
  }, []);

  const handleSubmit = async (e?: React.FormEvent, submitCode?: string) => {
    if (e) e.preventDefault();
    const finalCode = (submitCode || code).replace(/-/g, '').trim();
    if (!finalCode || finalCode.length < 6) {
      setError("Please enter a valid 6-character code.");
      return;
    }
    setLoading(true);
    setError(null);

    try {
        const result = await api.get<{ lesson: Lesson }>(`/api/v1/sessions/join/${finalCode}`);
        onStartSession(result.lesson);
    } catch (err) {
        if (err instanceof Error) setError(err.message);
        else setError("An unknown error occurred.");
    } finally {
        setLoading(false);
    }
  };

  return (
    <div className="w-full max-w-md">
      <form onSubmit={handleSubmit} className="bg-white p-8 rounded-lg shadow-lg text-center">
        <h2 className="text-3xl font-bold text-gray-800 mb-4">Join a Live Session</h2>
        <p className="text-gray-600 mb-6">Enter the 6-character code from your teacher to begin.</p>
        
        {error && <p className="text-red-500 mb-4">{error}</p>}
        
        <input
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          className="w-full p-4 border border-gray-300 rounded-md text-center text-3xl font-mono tracking-widest"
          placeholder="A4B9X1"
          maxLength={6}
        />

        <button
          type="submit"
          className="w-full py-3 mt-6 bg-blue-600 text-white rounded-md font-semibold text-lg hover:bg-blue-700 transition"
          disabled={loading}
        >
          {loading ? <LoadingSpinner message="Joining..." /> : "Join Session"}
        </button>
      </form>
    </div>
  );
};

export default JoinWithCode;